import { render, staticRenderFns } from "./HotRankingList.vue?vue&type=template&id=638fa3e9&scoped=true"
import script from "./HotRankingList.vue?vue&type=script&lang=js"
export * from "./HotRankingList.vue?vue&type=script&lang=js"
import style0 from "./HotRankingList.vue?vue&type=style&index=0&id=638fa3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fa3e9",
  null
  
)

export default component.exports